import styled from 'styled-components';

import OutputText from '@ey/canvascoreservices/OutputText';

export default styled(OutputText)`
	a {
		font-size: inherit;
		line-height: inherit;
		color: ${({theme}) => theme.color.blue600yellow400};
	}
`;
